import React from 'react';
import { Select } from '../../../../UI';
import { QueryType } from '../../../../../types/QueryTypes';

interface QueryTypeSelectorProps {
  workflow?: QueryType;
  onChange: (workflow?: QueryType) => void;
}

const QueryTypeSelector: React.FC<QueryTypeSelectorProps> = ({ workflow, onChange }) => {
  const options = [
    { value: '', label: 'Auto' },
    ...Object.values(QueryType).map((workflowValue) => ({
      value: workflowValue,
      label: workflowValue,
    })),
  ];

  const handleChange = (value: QueryType | undefined) => {
    onChange(value);
  };

  return (
    <Select<QueryType>
      label="Query Type"
      options={options}
      value={workflow}
      onChange={handleChange}
    />
  );
};

export default QueryTypeSelector;
